import styled from 'styled-components';

export const MarkedText = styled.span<{ $color?: string }>`
	color: ${props => (props.$color ? props.$color : props.theme.fontColors.accent)};
`;
